import { render, staticRenderFns } from "./application-bank-accounts.vue?vue&type=template&id=3b1c909c"
import script from "./application-bank-accounts.vue?vue&type=script&lang=js"
export * from "./application-bank-accounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports